<template>
  <div class="form-input-group">
    <el-row v-for="subCategory in input.SubCategories" :key="subCategory.id">
      <el-col :span="12">
        <h5 class="form-input-group--label">
          {{ subCategory.name }}
        </h5>
        <el-input
          v-model="group[subCategory.code].value"
          type="textarea"
          autosize
          class="w-100"
          :disabled="disabled"
          @change="updateValue(subCategory.code, subCategory.id, group[subCategory.code].value)">
        </el-input>
      </el-col>
    </el-row>
    <el-row v-if="input.description">
      <el-col :span="24">
        <div class="el-form-item__help">
          <p>{{ input.description }}</p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue';
import { each, isNil } from 'lodash';

export default {
  name: 'form-input-group',
  props: {
    input: {
      type: Object,
      required: true,
      default: null,
    },
    value: {
      required: true,
      default: null,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      group: {},
    };
  },
  methods: {
    updateValue(code, id, value) {
      this.$emit('set:value', {
        code,
        data: {
          id,
          value,
        },
      });
    },
  },
  created() {
    each(this.input.SubCategories, (subCategory) => {
      const id = subCategory.id;
      const value = subCategory.value;
      const code = subCategory.code;
      Vue.set(this.group, code, {
        id,
        value,
      });
      if (!isNil(value)) this.updateValue(code, id, value);
    });
  },
};
</script>

<style lang="scss" scoped>
  .form-input-group {
    >>> .el-row {
      margin-bottom: 0.75em;
    }
    .form-input-group--label {
      line-height: 1.15;
      font-size: 0.8rem;
      text-transform: uppercase;
      color: gray;
      padding: 0 0.5em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/consultation/form-input/cmpt-form-input-group.vue